import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const ActivityEntityExtraSchema = z.object({
  campaignManagerStartDate: z.string().nullish(),
  campaignManagerEndDate: z.string().nullish(),
  campaignManagerDefaultLandingPageUrl: z.string().nullish(),
});

export const ActivityEntityItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  extra: ActivityEntityExtraSchema.nullable().optional(),
});

export const ActivityEntitiesResponseSchema = createResponseSchema(
  ActivityEntityItemSchema,
);

export type ActivityEntityItemType = z.infer<typeof ActivityEntityItemSchema>;
export type ActivityEntitiesResponseType = z.infer<
  typeof ActivityEntitiesResponseSchema
>;
